export const NO_SHOP_ID = '-1';
export const UNKNOWN_LANG = 'mul';
